module.exports = __webpack_public_path__ + "img/qrContainer.54c27a71.png";